import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Smoothness = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322811477_PFI_MillLaboratory_Beater.png?alt=media&token=f1e3aa3c-9f6c-4751-afcf-94c6b084e8c5',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322811477_PFI_MillLaboratory_Beater.png?alt=media&token=f1e3aa3c-9f6c-4751-afcf-94c6b084e8c5'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>PFI Mill / Laboratory Beater </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>PFI Mill / Laboratory Beater </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    For laboratory use in the process of refining chemical pastes under standard conditions and even for the defibration of semi-cooked fibers. The refining elements consist of a mill with sharp vertical cutting bars and a container that houses the paper pulp sample to be refined, both elements made of stainless steel. The mill with blades and the circular container has an independent electric motor drive and rotate in the same direction but the refining mill has a higher peripheral speed. Deployment and the base plate are carried out independently and rotate in the same direction, but implementation has peripheral speed. Refining conditions, such as pulp consistency, refining pressure and the distance between the refining elements can vary within wide limits. The PFI type refining mill is equipped with a digital counter to record the mill turns during a pulp refining test.
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about PFI Mill / Laboratory Beater"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>

        </Layout >
    );
};

export default Smoothness
